import locale from '~/utils/locale'

export const currentYear = new Date().getFullYear()

export default locale.create<{
    copyright1: string
    copyright2: string
}>()
